import { assertNever } from '@/lib/typescript/assertNever'

export const toLoyaltyProgram = '/customer/loyalty'

export function toLoyaltyShop(authLink: string) {
  return `${authLink}&redirect=/boutique`
}

/**
 * URL to go to the loyalty rules PDF.
 */
export function toLoyaltyProgramRules() {
  // Can't succeed tests if this is retrieved outside
  const BRAND = process.env.NEXT_PUBLIC_BRAND

  switch (BRAND) {
    case 'prolians':
      return '/media/pdf/loyalty/reglement-prolians-et-moi.pdf'
    case 'hydralians':
      return '/media/pdf/loyalty/reglement-hydralians-et-moi.pdf'
    case 'dexis':
      return ''
    case 'destil_nl':
      return ''
    case 'ecom_en':
      return ''
    case 'dexis_nl':
      return ''
    default:
      assertNever(BRAND)
  }
}
